angular.module('impactx.login').service('LoginService', LoginService);

LoginService.$inject = [
    '$context',
    'dataGen',
    '$securityManager',
    '$redirect',
    '$mdDialog',
    'searchFilter',
    '$workspace',
    'basketTemplateMenu',
    'DeeplinkService',
    '$listCache',
    '$location',
    '$route',
    'BrowserSettings',
    'CubeConfigService',
    'TranslationService',
    '$rootScope',
    'SearchFilter',
    'SearchFilterStorage',
    '$config',
    'sidebarShow',
    'PaginationService',
    'SearchService',
    'AppConfiguration',
    'ixaSearchSignals',
    'cookieService',
    'ReloginExternalService',
];

function LoginService($context, dataGen, $securityManager, $redirect, $mdDialog, searchFilter, $workspace, basketTemplateMenu,
                      DeeplinkService, $listCache, $location, $route, BrowserSettings, CubeConfigService, TranslationService,
                      $rootScope, SearchFilter, SearchFilterStorage, $config, sidebarShow, PaginationService, SearchService,
                      AppConfiguration, ixaSearchSignals, cookieService, ReloginExternalService) {
    var loginService = this;
    this.model = {};

    this.lastLoginName = "";

    this.getCustomLoginData = function (value) {
        return dataGen.getData({}, {value: value, language: $rootScope.language}, "/customlogin");
    };

    this.getLastLoginName = function () {
        return this.lastLoginName;
    };

    this.login = function (username, passwd, stayLoggedIn, mfaCode) {
        var data = {
            passwd: passwd,
            loginio: username,
            stayLoggedIn: stayLoggedIn,
            language: TranslationService.getCurrentLanguage()
        };
        if (mfaCode) {
            data.mfaCode = mfaCode;
        }

        $securityManager.stayLoggedIn = stayLoggedIn;
        loginService.lastLoginName = username;

        //  $log.log('Login with: ', username);

        return refreshData(data, true);
    };

    this.loginOsu = function (passwd, osutan) {
        var data = {
            password: passwd,
            osutan: osutan
        };
        return dataGen.postAsForm(loginService.model, data, "/osu/loginandredirect").then(function (data) {
                loginService.refreshUI(false);
                if ($securityManager.isAuthorized()) {
                    $mdDialog.hide();
                    let dataInputNeeded = ($context.needsDataInput());
                    if (!dataInputNeeded) {
                        $redirect.redirectTo(null, data.data.osuredirect);
                    }
                }
            }
        );
    };

    this.closeDialogAndNavigateToLogin = function () {
        $mdDialog.hide();

        delete loginService.directRoute;

        loginService.logout();
    };

    this.logout = function () {
        delete loginService.directRoute;
        //  $log.log('Logout');

        return dataGen.getData({}, {smallMenuWasShown: (!sidebarShow.isOpen() && !($context.needsDataInput()))}, "/logout").then(function () {
            let loginPageCookie = cookieService.getCookieValue('loginPage');
            let isExternalUser = ReloginExternalService.isExternalUser();
            $securityManager.invalidate();
            $listCache.removeAll();
            $context.reset();
            $mdDialog.hide();

            if (isExternalUser) {
                $redirect.redirectTo(null, '/relogin.external');
            }
            else {
                if (loginPageCookie) {
                    $redirect.redirectTo(null, $config.customLoginRoute + '/' + loginPageCookie);
                }
                else {
                    $redirect.redirectTo(null, $config.loginRoute);
                }
            }
            $rootScope.$broadcast('logoutSuccess');
        });
    };

    this.refresh = function () {
        refreshData({}, false);
    };

    this.prepareLogin = function (dialogFunction) {
        if (!$securityManager.isAuthorized()) {
            $listCache.removeAll();
            $mdDialog.hide();

            dialogFunction();
        }
        else {
            if (loginService.directRoute) {
                $redirect.redirectTo(null, loginService.directRoute);
                return;
            }

            loginService.refresh();
            var goToRoute = "fallbackstartpage";

            if ($workspace.getCurrentWorkspaceView($workspace)) {
                goToRoute = $workspace.getCurrentWorkspaceView($workspace)
            }
            else if (DeeplinkService.getRecentDeeplink()) {
                goToRoute = DeeplinkService.getRecentDeeplink();
                DeeplinkService.deleteRecentDeeplink();
            }
            $redirect.redirectTo(null, goToRoute);
        }
    };

    this.refreshUI = function (withRedirect, osuTan, forcedRedirect) {
        if ($securityManager.isAuthorized()) {
            var directRedirectRoute,
                processes,
                data = loginService.model.data;

            ixaSearchSignals.init().then(() => {
                ixaSearchSignals.clientInfo();
            });

            if (data) {
                processes = data.processes;

                if (processes) {
                    $securityManager.setAllowedProcesses(processes);
                }

                if (data.redirect) {
                    directRedirectRoute = data.redirect;
                }
            }

            if (directRedirectRoute) {
                //More or less forced redirect
                $mdDialog.hide();
                loginService.directRoute = directRedirectRoute;

                //  $log.log("RefreshUI: Direct route: ", loginService.directRoute);
                //Redirected after login.
                $redirect.redirectTo(null, directRedirectRoute);
                return;
            }

            if ($securityManager.isOnlyAllowed("Auth")) {
                //  $log.log("Only Auth:Direct route: /pwreset");
                $redirect.redirectTo(null, "/pwreset");
                return;
            }

            if ($securityManager.isOnlyAllowed("CopyCC")) {
                $redirect.redirectTo(null, "/copyccuser");
                return;
            }


            $context.init({}, dataGen, $securityManager).then(function () {
                basketTemplateMenu.refreshAllTemplates();
                $context.refreshBasket({}, dataGen, $context);
                $context.refreshSearchInfo({}, dataGen, $context);
                $context.refreshUser({}, dataGen, $context);
                $context.startInfoMessagePolling();
                $context.startToDoMessagePolling();
                $context.startPushMessageLoginFetch(dataGen, $mdDialog);

                $workspace.refreshAvailableWorkspaces({}, dataGen, $context, $workspace).then(function () {
                    CubeConfigService.deleteCache();
                    PaginationService.resetNumberOfLinesPerList();
                    SearchService.setNumberOfProductRows(AppConfiguration.get('numberOfProductsInSearch'));
                    if (searchFilter) {
                        searchFilter.deleteSearchFilterData();
                        if ($securityManager.isProcessAllowed("Search")) {
                            SearchFilterStorage.reset();
                            searchFilter.wasInitialized = false;
                            searchFilter.initSearchFilter();
                            SearchFilter.initialize();
                        }
                    }
                    if (withRedirect || $context.needsDataInput()) {
                        var goToRoute = "fallbackstartpage";

                        if(forcedRedirect)
                        {
                            $redirect.redirectTo(null, forcedRedirect);
                            return;
                        }

                        if (osuTan && !$context.needsDataInput()) {
                            $workspace.getCurrentWorkspaceId().value = "shop";
                            goToRoute = "osulink/" + osuTan;
                        }
                        else if (DeeplinkService.getRecentDeeplink() && !$context.needsDataInput()) {
                            $workspace.getCurrentWorkspaceId().value = "shop";
                            goToRoute = DeeplinkService.getRecentDeeplink();
                            DeeplinkService.deleteRecentDeeplink();
                        }
                        else if ($workspace.getCurrentWorkspaceView($workspace)) {
                            goToRoute = $workspace.getCurrentWorkspaceView($workspace)
                        }
                        if ($location.path() === goToRoute) {
                            //reload needed if we stay in the current location.
                            $route.reload()
                        }
                        else {
                            $redirect.redirectTo(null, goToRoute);
                        }
                    }
                });
            });
        }
    };

    function refreshData(data, withRedirect) {
        return dataGen.postAsForm(loginService.model, data, "/lobby").then(function () {
                loginService.refreshUI(withRedirect);
                if ($securityManager.isAuthorized()) {
                    $mdDialog.hide();
                }
            }
        );
    }
}
